import { Region, CallbackRegion } from '@okletsplay/core';

const CALLBACK_REGION: Record<Partial<Region>, string> = {
  [Region.Brazil]: CallbackRegion.BR1,
  [Region.EuropeNordic]: CallbackRegion.EUN1,
  [Region.EuropeWest]: CallbackRegion.EUW1,
  [Region.LatinAmericaNorth]: CallbackRegion.LA1,
  [Region.LatinAmericaSouth]: CallbackRegion.LA2,
  [Region.NorthAmerica]: CallbackRegion.NA1,
  [Region.Oceania]: CallbackRegion.OC1,
  [Region.Russia]: CallbackRegion.RU,
  [Region.Turkey]: CallbackRegion.TR1,
  [Region.Japan]: CallbackRegion.JP1,
  [Region.RepublicOfKorea]: CallbackRegion.KR,
  [Region.PublicBetaEnvironment]: CallbackRegion.PBE1,
};

export const lolProviderRegionConverter = (region: Region): string => {
  const callbackRegion = CALLBACK_REGION[region];

  return callbackRegion ?? region;
};
